import React, { useState } from 'react';

const Feedback = () => {
  const [message, setMessage] = useState<any>('');
  const [submitted, setSubmitted] = useState<any>(false);

  return (
    <div>
      <div style={{ fontSize: 26, fontWeight: 800, color: '#1e3a5f', marginBottom: 20 }}>Feedback</div>
      <div style={{ background: 'white', border: '1px solid #e0e7ef', borderRadius: 14, padding: '24px 28px', maxWidth: 560, boxShadow: '0 1px 4px #0001' }}>
        {submitted ? (
          <div style={{ textAlign: 'center', padding: '24px 0' }}>
            <div style={{ fontSize: 36, marginBottom: 12 }}>✅</div>
            <div style={{ fontWeight: 700, fontSize: 16, color: '#1e3a5f', marginBottom: 8 }}>Thank you for your feedback!</div>
            <button onClick={() => { setMessage(''); setSubmitted(false); }} style={{ background: '#2563eb', color: 'white', border: 'none', borderRadius: 8, padding: '8px 20px', fontWeight: 700, fontSize: 13, cursor: 'pointer', marginTop: 8 }}>Submit Another</button>
          </div>
        ) : (
          <>
            <div style={{ fontSize: 15, color: '#374151', marginBottom: 16 }}>We'd love to hear from you. Share your thoughts or concerns below.</div>
            <textarea
              value={message}
              onChange={e => setMessage(e.target.value)}
              placeholder="Type your feedback here..."
              rows={5}
              style={{ width: '100%', border: '1.5px solid #c7d7fc', borderRadius: 10, padding: '10px 12px', fontSize: 13, color: '#1e3a5f', resize: 'vertical', boxSizing: 'border-box', outline: 'none', fontFamily: 'inherit' }}
            />
            <button
              disabled={!message.trim()}
              onClick={() => setSubmitted(true)}
              style={{ marginTop: 14, background: message.trim() ? '#2563eb' : '#9ca3af', color: 'white', border: 'none', borderRadius: 10, padding: '10px 24px', fontWeight: 700, fontSize: 14, cursor: message.trim() ? 'pointer' : 'not-allowed', width: '100%' }}
            >
              Submit Feedback
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Feedback;
